import type { ImageSourcePropType } from "react-native";
import day3Embryos from "../../assets/images/outcome-funnel/day-3-embryos.png";
import day5Embryos from "../../assets/images/outcome-funnel/day-5-embryos.png";
import embryoTransfer from "../../assets/images/outcome-funnel/embryo-transfer.png";
import fertilizedEggs from "../../assets/images/outcome-funnel/fertilized-eggs.png";
import frozenEggs from "../../assets/images/outcome-funnel/frozen-eggs.png";
import frozenEmbryos from "../../assets/images/outcome-funnel/frozen-embryos.png";
import frozenSpermStorage from "../../assets/images/outcome-funnel/frozen-sperm-storage.png";
import insemination from "../../assets/images/outcome-funnel/insemination.png";
import matureEggs from "../../assets/images/outcome-funnel/mature-eggs.png";
import ovulationInduction from "../../assets/images/outcome-funnel/ovulation-induction.png";
import pregnancyOutcome from "../../assets/images/outcome-funnel/pregnancy-outcome.png";
import retrievedEggs from "../../assets/images/outcome-funnel/retrieved-eggs.png";
import spermCollected from "../../assets/images/outcome-funnel/sperm-collected.png";

export type OutcomeFunnelIllustrationKey =
  | "retrieved-eggs"
  | "mature-eggs"
  | "fertilized-eggs"
  | "day-3-embryos"
  | "day-5-embryos"
  | "frozen-eggs"
  | "frozen-embryos"
  | "embryo-transfer"
  | "pregnancy-outcome"
  | "insemination"
  | "ovulation-induction"
  | "sperm-collected"
  | "frozen-sperm-storage";

export const OUTCOME_FUNNEL_ILLUSTRATIONS: Record<
  OutcomeFunnelIllustrationKey,
  ImageSourcePropType
> = {
  "retrieved-eggs": retrievedEggs,
  "mature-eggs": matureEggs,
  "fertilized-eggs": fertilizedEggs,
  "day-3-embryos": day3Embryos,
  "day-5-embryos": day5Embryos,
  "frozen-eggs": frozenEggs,
  "frozen-embryos": frozenEmbryos,
  "embryo-transfer": embryoTransfer,
  "pregnancy-outcome": pregnancyOutcome,
  insemination,
  "ovulation-induction": ovulationInduction,
  "sperm-collected": spermCollected,
  "frozen-sperm-storage": frozenSpermStorage,
};
